import React from 'react';
import { CTAButton } from '../CTAButton';
import { AUTHOR_IMAGE } from '../../data/content';
export function AboutAuthor() {
  return <section className="w-full bg-white px-4 py-12 sm:py-16" data-id="element-49" data-mp="2hfwfzys611gq">
      <div className="mx-auto max-w-3xl" data-id="element-50" data-mp="2m7nyrn52y2wb">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-forest" data-id="element-51" data-mp="2m8z9y80uucxg">
          👩‍⚕️ About Dr. Karito
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-52" data-mp="1tk1t89cako6t">
          A Message from Dr. Karito
        </h2>

        <div className="mt-8 grid gap-6 sm:grid-cols-[minmax(0,240px)_minmax(0,1fr)] sm:items-start sm:gap-8" data-id="element-53" data-mp="1ykg37wxge87h">
          <img src={AUTHOR_IMAGE} alt="Portrait of Dr. Karito wearing a white coat in her clinic" className="mx-auto w-full max-w-[240px] rounded-3xl object-cover shadow-card" loading="lazy" data-id="element-54" data-mp="27j9wpefhmigt" />

          <div className="space-y-3.5 text-[15px] font-medium leading-relaxed text-ink/75" data-id="element-55" data-mp="3ix57yc39u72r">
            <p data-id="element-56" data-mp="2aq0e60ywrzgb">For years, I saw doctors facing the same problem:</p>
            <p className="font-bold text-navy-deep" data-id="element-57" data-mp="25rp3xp4pbmxk">
              they didn’t lack knowledge. They lacked a practical methodology that allowed them to
              apply that knowledge quickly, consistently, and confidently during a real consultation.
            </p>
            <p data-id="element-58" data-mp="1vwf14z6hbbiq">
              International guidelines are valuable, but they aren’t always designed to answer the
              questions that arise when you have a real patient sitting in front of you.
            </p>
            <p data-id="element-59" data-mp="1i2eakspokutg">That’s why I created this Clinical Kit.</p>
            <p data-id="element-60" data-mp="1i2xidglma2tr">
              A complete Clinical Pathway that brings the most important information, decision-making
              tools, algorithms, and practical resources together in one place.
            </p>
            <p className="font-bold text-navy-deep" data-id="element-61" data-mp="186knifec5ixf">
              My goal is simple: spend less time searching for information and more time making
              confident clinical decisions.
            </p>
            <p className="font-display text-lg font-bold text-forest" data-id="element-62" data-mp="tk456hn8ox81">— Dr. Karito</p>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-63" data-mp="khcq87v5njbn">
          <CTAButton label="I want to follow the Clinical Pathway" sub="Methodology used by 2,000+ doctors" data-id="element-64" data-mp="kintm6koup28" />
        </div>
      </div>
    </section>;
}